module.exports = __webpack_public_path__ + "img/change-arrow.27c706a1.svg";